module.exports = __webpack_public_path__ + "img/card-logos.cb221add.png";